// WhatsApp Floating Button
const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/34600221794?text=Hola%20%F0%9F%91%8B%20Quiero%20reservar%20un%20transfer%20desde%20el%20aeropuerto%20de%20M%C3%A1laga%0ADestino%3A%20%0AFecha%20y%20hora%20de%20llegada%3A%20%0AN%C2%BA%20vuelo%3A%20%0AN%C2%BA%20pasajeros%3A%20"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-btn-new"
      aria-label="Reserva por WhatsApp"
      data-testid="whatsapp-floating-btn"
    >
      <i className="fab fa-whatsapp mr-2"></i>
      Reserva por WhatsApp 24h
    </a>
  );
};

export default WhatsAppButton;
